import React from "react";

// Contenu du tutoriel de l'écran "Suivi Traitements comptables" — étapes
// (image + titre + description) affichées par le composant générique
// TutorialOverlay (src/components/ui/TutorialOverlay.js). description est du
// JSX (pas juste du texte) pour pouvoir mettre en gras les informations clés.
// Chaque nouvelle section de la plateforme ayant son propre tutoriel ajoute
// un fichier similaire ici (ex. PortefeuilleTutorial.js, SuiviComptaTutorial.js...).
const traitementsComptablesTutorial = [
  {
    image:
      "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/Suvi%20traitement%20comtpable/Capture%20d%E2%80%99%C3%A9cran%202026-07-21%20142430.png",
    title: "Comment créer un dossier de traitement comptable ?",
    legende: "Création d'un événement — catégorie « Arrivée pièces comptables »",
    description: (
      <>
        Créez un <strong>Événement</strong> : choisissez le client, puis
        sélectionnez <strong>« Arrivée pièces comptables »</strong> dans{" "}
        <strong>Catégorie</strong>. Renseignez la <strong>Période</strong>, la{" "}
        <strong>Nature des pièces</strong> et <strong>notifiez au moins
        une personne</strong> — ces trois champs sont obligatoires, sinon{" "}
        <strong>le bouton reste bloqué</strong>.
        <br />
        <br />
        Dès la validation, <strong>tout se déclenche automatiquement</strong>{" "}
        : le dossier apparaît dans le tableau Traitements comptables, la
        mission « Arrive PC » est déjà validée dans Suivi Compta, et un mail
        part aux personnes notifiées.
        <br />
        <br />
        Point important :{" "}
        <strong>
          le mois et l'année de la date de création de cet événement
        </strong>{" "}
        deviennent la référence pour tout le dossier dans Suivi Compta — même
        si les étapes sont clôturées plus tard, parfois le mois suivant,{" "}
        <strong>c'est toujours ce mois-là qui sera alimenté</strong>.
      </>
    ),
  },
  {
    image:
      "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/Suvi%20traitement%20comtpable/Capture%20d%E2%80%99%C3%A9cran%202026-07-21%20143126.png",
    title: "Le dossier apparaît automatiquement dans le tableau",
    legende: "Le tableau Traitements comptables après création de l'événement",
    description: (
      <>
        Le dossier apparaît avec ses <strong>3 étapes</strong>, chacune liée
        à une mission Suivi Compta : clôturer{" "}
        <strong>Numérisation & Dépôt</strong> valide{" "}
        <strong>« Tri et numérisation »</strong>, clôturer{" "}
        <strong>Pré-compta</strong> valide{" "}
        <strong>« Traitement niv.2 »</strong>, clôturer{" "}
        <strong>Révision</strong> valide <strong>« Traitement niv.1 »</strong>.
        <br />
        <br />
        Si un collaborateur niveau 1 ou niveau 2 est déjà renseigné sur la
        fiche Portefeuille du client, les{" "}
        <strong>étapes 2 et 3 sont pré-affectées automatiquement</strong> —
        sinon elles restent « à affecter ».
        <br />
        <br />
        Important :{" "}
        <strong>
          chaque étape est bloquée tant que la précédente n'est pas clôturée
        </strong>{" "}
        — impossible d'affecter ou de clôturer l'étape 2 avant la fin de
        l'étape 1, et ainsi de suite.
      </>
    ),
  },
  {
    image:
      "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/Suvi%20traitement%20comtpable/Capture%20d%E2%80%99%C3%A9cran%202026-07-21%20143100.png",
    title: "Comment affecter un collaborateur à une étape ?",
    legende: "Affectation d'un collaborateur sur une mission",
    description: (
      <>
        <strong>Cliquez sur le nom du collaborateur</strong> (ou sur
        « Affecter... » si personne n'est désigné) pour choisir la bonne
        personne, ou <strong>« Non affecté »</strong> pour retirer
        l'affectation.
        <br />
        <br />
        Dès qu'une personne est choisie,{" "}
        <strong>un mail automatique part immédiatement</strong> pour
        l'informer qu'un dossier lui est affecté — aucune action
        supplémentaire à faire.
        <br />
        <br />
        Tant qu'une étape n'a personne d'affecté,{" "}
        <strong>elle ne peut pas être clôturée</strong> : le bouton de
        clôture reste inactif.
      </>
    ),
  },
  {
    image:
      "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/Suvi%20traitement%20comtpable/Capture%20d%E2%80%99%C3%A9cran%202026-07-21%20143211.png",
    title: "Une fois affecté : échéance, notification et clôture",
    legende: "Collaborateur affecté et échéance saisie",
    description: (
      <>
        Une fois un collaborateur affecté, l'étape passe en{" "}
        <strong>« En cours »</strong>. Fixez une échéance si besoin — si elle
        est dépassée sans clôture,{" "}
        <strong>l'étape est automatiquement marquée « en retard »</strong> et
        remontée en priorité dans « Charge par collaborateur ».
        <br />
        <br />
        Deux icônes sont disponibles : la <strong>cloche</strong> envoie un
        rappel manuel au collaborateur affecté, la <strong>coche</strong>{" "}
        ouvre le formulaire de clôture.
        <br />
        <br />
        Valider la clôture déclenche{" "}
        <strong>deux choses en même temps</strong> : la mission
        correspondante est <strong>validée automatiquement</strong> dans
        Suivi Compta, et{" "}
        <strong>un mail part au collaborateur qui prend la main</strong> sur
        l'étape suivante (celui déjà affecté, ou celui choisi manuellement
        dans « Notifier »).
      </>
    ),
  },
  {
    image:
      "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/Suvi%20traitement%20comtpable/Capture%20d%E2%80%99%C3%A9cran%202026-07-21%20143310.png",
    title: "L'impact automatique dans Suivi Compta",
    legende: "Le tableau Suivi Compta mis à jour automatiquement",
    description: (
      <>
        Sans y toucher, le tableau <strong>Suivi Compta</strong> se met à
        jour : la barre de progression avance sur{" "}
        <strong>le mois et l'année de création de l'événement</strong> —
        jamais la date de clôture d'une étape (voir l'étape 1).
        <br />
        <br />
        Chaque création d'événement (mission « Arrive PC ») et{" "}
        <strong>chaque clôture d'étape</strong> valide automatiquement la
        mission correspondante ici, avec les informations reprises de
        l'étape (commentaire, temps de traitement, nombre de documents...) —
        aucune saisie n'est nécessaire sur cet écran.
      </>
    ),
  },
  {
    image:
      "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/Suvi%20traitement%20comtpable/Capture%20d%E2%80%99%C3%A9cran%202026-07-21%20143324.png",
    title: "Le détail du mois : ce qui est déjà fait, ce qu'il reste à faire",
    legende: "Détail des missions du mois, données reprises automatiquement",
    description: (
      <>
        Cliquez sur une case du tableau Suivi Compta pour ouvrir le détail
        des <strong>5 missions du mois</strong>.
        <br />
        <br />
        Les 4 premières — Arrive PC, Tri et numérisation, Traitement niv.2,
        Traitement niv.1 — sont alimentées automatiquement par l'événement et
        les clôtures d'étapes ; elles s'affichent en{" "}
        <strong>« Consulter »</strong>.
        <br />
        <br />
        La 5ᵉ, <strong>le Bouclage mensuel, n'est jamais automatique</strong> :
        renseignez-la manuellement (TVA, IS, TS, CFE, volume de pièces
        manquantes...), soit ici, soit via la question posée après la
        clôture de l'étape Révision.
      </>
    ),
  },
];

export default traitementsComptablesTutorial;
